import { THoldingInfo, TPositions, TPrincipalPositions, TWalletData, TWalletProductInfo } from "../types/PrincipalPositionTypes";

type TFormatTableDistributionRelationsProps = {
    walletRelationsInfo: TWalletProductInfo[] ;
    principalPositionsList: TPrincipalPositions[];
};

export const FormatTableDistribution = (
  { walletRelationsInfo, principalPositionsList }: TFormatTableDistributionRelationsProps
): TWalletData => {

  const companys = agruparPositionsPorIsin(principalPositionsList);

  const result: TWalletData = {
    walletProductInfo: [],
    holdingInfo: [],
  };

  const others: THoldingInfo = {
    holdingName: "Others",
    holdingSumatory: 0,
    holdingFundWeight: [],
    holdingPercentaje: []
  };

  result.walletProductInfo = walletRelationsInfo;


  if (companys.size > 0) {
    companys.forEach((positions, _) => {
      const localHolding: THoldingInfo = {
        holdingName: positions.length > 0 ? positions[0].name : 'Desconocido',
        holdingSumatory: 0,
        holdingFundWeight: [],
        holdingPercentaje: []
      };

      const positionMap = new Map<string, TPositionConReferencia>();
      positions.forEach(pos => {
        positionMap.set(pos.principalIsin, pos);
      });

      const holdingXFunds = walletRelationsInfo.map(wallet => {
        const exist = positionMap.get(wallet.isin);
        return exist
          ? wallet.weight > 0.001
            ? Number((wallet.weight * exist.percentaje).toFixed(2))
            : exist.percentaje * wallet.weight
          : 0;
      });

      const fundsPercentaje = walletRelationsInfo.map(wallet => {
        const exist = positionMap.get(wallet.isin);
        return exist
          ? wallet.weight > 0.001
            ? Number((exist.percentaje).toFixed(2))
            : exist.percentaje
          : 0;
      });

      if (holdingXFunds.length > 0) {
        const sumatory = holdingXFunds.reduce((acc, current) => acc + current, 0);
        others.holdingSumatory += sumatory;
        localHolding.holdingPercentaje = fundsPercentaje;
        localHolding.holdingSumatory = Number(sumatory.toFixed(2));
        localHolding.holdingFundWeight = holdingXFunds;
        result.holdingInfo.push(localHolding);
      }
    });
  }

  const arrayFunds = result.holdingInfo.map(holds => holds.holdingFundWeight);  

  // SUMATORIO DE COLUMNAS
  const arrayPercentajes = result.holdingInfo.map(h => h.holdingPercentaje);
  const resultadoPercentajes = arrayPercentajes.reduce((acc, curr) =>
    acc.map((value, index) => (value ?? 0) + (curr[index] ?? 0))
  );

  others.holdingPercentaje = resultadoPercentajes.map(v =>
    v > 0.01 ? 100 - Number(v.toFixed(2)) : 100 - Math.floor(v * 100) / 100
  );

  if (arrayFunds.length > 0){
    const resultado = arrayFunds.reduce((acc, curr) => 
      acc.map((value, index) => value + curr[index])
    );

    const decimalsFormatSumatory = resultado.map(res => {
      return res > 0.01
        ? Number((100 - res).toFixed(2))
        : Math.floor((100 - res) * 100) / 100
    });
    others.holdingSumatory = Number((100 - others.holdingSumatory).toFixed(2));
    others.holdingFundWeight = decimalsFormatSumatory;
    result.holdingInfo = result.holdingInfo.sort((a, b) => b.holdingSumatory - a.holdingSumatory);
    
    result.holdingInfo.push(others);
  }

  return result;
};

type TPositionConReferencia = TPositions & { principalIsin: string };

const agruparPositionsPorIsin = (data: TPrincipalPositions[]) => {
  const agrupados = new Map<string, TPositionConReferencia[]>();

  data.forEach(principal => {
    principal.positions.forEach(position => {
      const positionConRef: TPositionConReferencia = {
        ...position,
        principalIsin: principal.isin,
      };

      if (!agrupados.has(position.isin)) {
        agrupados.set(position.isin, []);
      }
      agrupados.get(position.isin)!.push(positionConRef);
    });
  });

  return agrupados;
};
